var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.375,
    height: 25.375,
    viewBox: "0 0 25.375 25.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10807",
    "data-name": "Group 10807",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10978",
    "data-name": "Path 10978",
    d: "M12.688,0A12.688,12.688,0,1,1,0,12.688,12.688,12.688,0,0,1,12.688,0Z",
    transform: "translate(0 0)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(6.421 5.608)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 13.945,
    transform: "translate(6.979)",
    fill: "none",
    stroke: "#003049",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 14.208,
    transform: "translate(14.208 7.095) rotate(90)",
    fill: "none",
    stroke: "#003049",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon5);
export default __webpack_public_path__ + "static/media/plus_icon5.1bef113e44b99486177cfeebf08a77cb.svg";
export { ForwardRef as ReactComponent };